import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "./FloatingContacts.css";

const PHONE_NUMBER = "01034016811";
const WHATSAPP_NUMBER = "201034016811";

const FloatingContacts = () => {
    return (
        <div className="floating-contacts">
            <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                className="floating-contact whatsapp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="تواصل معنا عبر واتساب"
            >
                <FontAwesomeIcon icon={faWhatsapp} />
            </a>

            <a
                href={`tel:${PHONE_NUMBER}`}
                className="floating-contact phone"
                aria-label="اتصل بنا عبر الهاتف"
            >
                <FontAwesomeIcon icon={faPhone} />
            </a>
        </div>
    );
};

export default FloatingContacts;

